import {CompanyConfig} from '../types';
import {baseRoles, mergeWithDefaults} from './base.config';

const {labels, features, roles} = mergeWithDefaults(
  {
    order: 'Job',
    orders: 'Jobs',
    customer: 'Client',
    customers: 'Clients',
    dispatch: 'Job Assignment',
    deliveries: 'Jobs',
  },
  {
    hasOfferingTypeFilterOnOrders: true,
    hasServiceOnOrderCreation: true,
    hasJobDescriptionOnOrderCreation: true,
    hasServicesOnOrderDetails: true,
    hasServicesOnOffering: true,
    hasMergeOrdersOnOrderList: true,
  },
  baseRoles
);

export const insuranceAdjusterConfig: CompanyConfig = {
  type: 'insurance_adjuster',
  labels,
  features,
  roles,
};
